import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const StyledFlex = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${token.spacing5};
    flex-wrap: nowrap;
    overflow-x: scroll;
    width: 100%;
    padding: ${token.spacing2};
`;
